import axios from 'axios';

let prefix = "/category"

const CategoryApi = {
	
	getCategoryListAll(payload){
		return axios.get( prefix + "/list-all", {params: payload})
	},
	getCategoryList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getCategoryById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createCategory(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateCategory(payload){
		return axios.post( prefix + "/update", payload)
	},
	archiveCategory(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},

	getCategoryTagListAll(payload) {
		return axios.get('/api/category-tag/list', { params: payload })
	},

}

export default CategoryApi;